export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f0fe757ff0b94ac76b8743619192b0a18352c9249&name=fetchTypeahead!'